<template>
  <div>
    <div class="search-content">

      <el-col :span="24" class="toobar">
        <el-row>
          <el-col :span="3">
            <el-input placeholder="请选择商品" v-model="seedname" clearable @click.native="showGoodDetailSel" size="mini" @clear="clearSeedCode"></el-input>
          </el-col>
          <el-col :span="19">
            <el-select v-model="independentserial" @change="bindGrid(false)" filterable size="small" v-if="false">
              <el-option v-for="item in idd" :key="item.serialnum"
                         :label="item.dname"
                         :value="item.serialnum">
              </el-option>
            </el-select>
            <el-input style="width:200px;" v-if="false"
                      placeholder="输入销售单号或采购单号"
                      prefix-icon="el-icon-search"
                      v-model="searchdata" clearable>
            </el-input>
            <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid(false)" size="mini">搜索</el-button>
          </el-col>
        </el-row>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="tableHeight(180)"
      size="mini"
      stripe
      border
      style="width: 100%;">
      <el-table-column
        width="50" fixed
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index}}
        </template>
      </el-table-column>
      <el-table-column
        prop="erpserial" width="120"
        label="单号"
        header-align="center"
        align="center" >
      </el-table-column>
      <el-table-column
        prop="adddate"
        label="提交日期"
        header-align="center"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="seedname"
        label="名称" width="180"
        :show-overflow-tooltip="true"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="seedcode"
        label="编码"
        header-align="center"
        width="120" :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="packagesize"
        label="规格"
        align="left" :show-overflow-tooltip="true"
        header-align="center" width="150">
      </el-table-column>
      <el-table-column
        prop="ordername"
        label="类别"
        align="left"
        header-align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="原因" :show-overflow-tooltip="true"
        align="left"
        header-align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="cangkuname"
        label="仓库"
        header-align="center"
        align="left"
        width="100">
      </el-table-column>
      <el-table-column
        prop="totalnumber"
        label="数量"
        header-align="center"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="ordernum"
        label="销售单号"
        header-align="center"
        align="center"
        width="120" >
      </el-table-column>
      <el-table-column
        prop="buyordernum"
        label="采购单号"
        header-align="center"
        align="center"
        width="120" >
      </el-table-column>
      <el-table-column
        prop="uname"
        label="录入人"
        header-align="center"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column label="操作" align="center" width="70" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="confirmBuy(scope.row)">处理
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <BaoSunDetail ref="BaoSunDetail" @bindGrid="bindGrid"></BaoSunDetail>
    <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
  </div>

</template>

<script>
  import {independentDept} from '@/api/set/dept';
  import {badneedbuy} from '@/api/set/warehouse'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import JxcgooddetailSel from '../set/jxcgooddetail/JxcgooddetailSel'
  import BaoSunDetail from '../testorder/cstagreement/BaoSunDetail'

  export default {
    name: 'StorageBadWaitBuy',
    data() {
      return {
        msg: '待采购de坏件入库单',
        userInfoModel: {},
        dialogFormVisible: false,
        searchdata: "",
        independentserial: "",
        idd:[],
        tableData: [],
        cangkucode:'',
        seedname: '',
        seedcode: ''
      }
    },
    props: {
      mystatus: {
        default: ''
      },
      roletype:{
        default:''
      },
      canMultySelect: {
        default: true
      }
    },
    methods: {
      //显示商品选择页面
      showGoodDetailSel() {
        this.$refs.JxcgooddetailSel.show()
      },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.bindGrid()
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
        this.bindGrid()
      },
      isEqualIndependentSerial(item) {//总部人员只能操作总部的数据，加工中心只能操作加工中心的数据
        return this.userInfoModel.independentserial == (item.independentserial || "")
      },
      getPackagesize(packagesize) {
        let s = ""
        if (packagesize) {
          let temp = JSON.parse(packagesize)
          if(temp.M)
            return temp.M+'-'+temp.C;
          s = "S:" + (parseFloat(temp.Y) > 0 ? "+" + temp.Y : temp.Y) + ",C:" + (parseFloat(temp.X) > 0 ? "+" + temp.X : temp.X)
        }
        return s
      },
      bindGrid(rebindtip) {
        this.tableData = []
        var params = {
          cangkucode: this.cangkucode,
          search: this.searchdata,
          seedcode: this.seedcode,
          independentserial: this.independentserial
        }
        badneedbuy(params).then(response => {
          var data = response.data.obj
          this.tableData = data
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].packagesize = this.getPackagesize(this.tableData[i].packagesize);
          }
        }).catch((error) => {
          console.log(error)
        });
        if (rebindtip) {
          this.$emit("bindTip")
        }
      },
      //发起采购
      confirmBuy(row) {
        this.$refs.BaoSunDetail.showbuy(row.erpserial)
      },
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      //默认值
      this.independentserial = this.userInfoModel.independentserial;
      this.bindGrid(false);

      // independentDept().then(response => {
      //   this.idd = response.data.obj
      //   if (this.userInfoModel.independentserial != "") {
      //     //此时是经销商账户登录，且是订单或者客服菜单进入，  需要在服务部门下拉框增加  总部 选项
      //     this.idd.unshift({serialnum: "", dname: this.userInfoModel.tenantname})
      //   }
      //   this.idd.unshift({serialnum: "all", dname: "全部"})
      //
      // })
    },
    components: {
      JxcgooddetailSel,
      BaoSunDetail
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/warehouse/StorageBadWaitBuy.vue